import { ABP, eLayoutType } from '@abp/ng.core';

export const OFERTA_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/ofertas',
    iconClass: 'fas fa-dolly',
    name: 'Emissão de Embarque',
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.Ofertas',
    breadcrumbText: 'Emissão de Embarque',
    order: 2
  },
];
